export const VALID_DATA_STATUS = {
    OK: 'ok',
    INVALID: 'invalid',
    NONE: 'none'
}

export const MAPPING_STATUS = {
    NEW: 'new',
    MAPPED: 'mapped',
    REPLICATED: 'replicated',
    ERROR: 'error'
}

export default {
    methods: {
        formatAddress(a = {}) {
            const local = a.local ? `/${a.local}` : ''
            const postalCode = a.postalCode || a.postal_code || ''

            return `${a.street || ''} ${a.building || ''}${local}, ${postalCode} ${a.city || ''}`
        },

        areLocationsEqual(firstLoc, secondLoc) {
            const normalize = (value) => String(value || '').trim().toLowerCase()

            const normalizeAddress = (address) => ({
                street: normalize(address.street),
                building: normalize(address.building),
                local: normalize(address.local),
                city: normalize(address.city),
                postalCode: normalize(address.postalCode || address.postal_code)
            })

            const firstAddress = normalizeAddress(firstLoc.address || {})
            const secondAddress = normalizeAddress(secondLoc.address || {})

            return (
                normalize(firstLoc.name) === normalize(secondLoc.name) &&
                Object.keys(firstAddress).every(key => firstAddress[key] === secondAddress[key])
            )
        },

        clearLocationMappingFlow() {
            return this.$store.dispatch('resetDrsLocationMappingState')
        },

        closeModalAndClearState() {
            this.clearLocationMappingFlow()
            this.$store.dispatch('toggleModal', false)
        }
    }
}